import React, { useEffect } from 'react';

import { JobCardData } from '@xing-com/crate-dream-machine-types';

import { CardType } from '../../components/cards';
import { useSearchAndShuffleContext, useDeckCardIndex } from '../../context';
import { useTracking } from '../../use-tracking';

import { Company } from './company';
import { Facts } from './facts';
import { FirstTakenJobTooltip } from './first-taken-job-tooltip';
import { MainArea, Container } from './job-card.styled';
import { SalaryTile } from './salary-tile';
import { SkillsTile } from './skills-tile';
import { TitleAndMemberInfo } from './title-and-member-info';

export type JobCardProps = {
  data: JobCardData;
};

export const JobCard: React.FC<JobCardProps> = ({ data }) => {
  const { trackInView } = useTracking();
  const deckIndex = useDeckCardIndex();
  const { decks } = useSearchAndShuffleContext();

  useEffect(() => {
    if (deckIndex === undefined) return;
    const dataFirstCard = decks[deckIndex]?.cards[0].data;

    if (data?.urn && data?.trackingToken && data.id === dataFirstCard.id) {
      trackInView({
        itemUrn: data.urn,
        trackingToken: data.trackingToken,
        status: data.type,
        cardType: 'job_reco',
        position: deckIndex,
      });
    }
  }, [data]);

  return (
    <Container data-qa="job-card">
      <CardType type={data.type} />
      <FirstTakenJobTooltip />
      <TitleAndMemberInfo data={data} />
      <Company />
      <MainArea>
        <Facts />
        <SkillsTile />
        <SalaryTile />
      </MainArea>
    </Container>
  );
};
